module.exports = __webpack_public_path__ + "static/meteor-maze-icon-4850377dff1a7839c4e7cff8131283c7.png";